import { Box, Button, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import AuthContext from "../../../CONTEXT/AuthProvider";
import { useContext } from "react";

const AddSubscriber = () => {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = async (values) => {
    const subscriberCode = values.subscriberCode;
    const subscriberName = values.subscriberName;
    try {
      const data = {
        subscriberCode,
        subscriberName,
      };

      await axios.post("/api/register-subscriber", data, {
        headers: {
          'Authorization': 'Bearer ' + accessToken
        }
      });
      toast.success("Subscriber added successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="ADD SUBSCRIBER"
            subtitle="Create a new subscriber in the system"
          />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Subscriber Code"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.subscriberCode}
                    name="subscriberCode"
                    error={!!touched.subscriberCode && !!errors.subscriberCode}
                    helperText={touched.subscriberCode && errors.subscriberCode}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Subscriber Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.subscriberName}
                    name="subscriberName"
                    error={!!touched.subscriberName && !!errors.subscriberName}
                    helperText={touched.subscriberName && errors.subscriberName}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained">
                    Create New Subscriber
                  </Button>
                </Box>
                <ToastContainer />
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  subscriberCode: yup.string().required("required"),
  subscriberName: yup.string().required("required"),
});
const initialValues = {
  subscriberCode: "",
  subscriberName: "",
};

export default AddSubscriber;
